import routerData from './routerData'

export default {
  getNewRouerData: (role) => {
    let arr = computeRoute(role, routerData)
    arr.push({ path: '*', redirect: '/error' })
    return arr
  }
}

function computeRoute(role, route) {
  for (let i = 0; i < route.length; i++) {
    route = route.filter(val => {
      if (role.indexOf(val.name) > -1) {
        if (val.children) {
          val.children = computeRoute(role, val.children)
          val.redirect = (val.children[0] || {}).path
        }
        return val
      }
    })
  }
  return route
}
